import(/* webpackMode: "eager" */ "/tmp/8de79e93c510c24/src/modules/features/authentication/components/SignInBox/SignInBox.tsx");
